module.exports = __webpack_public_path__ + "static/img/model_ksd.f6534221.jpg";